var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor_video"},[(_vm.current==1)?_c('create-audio',{on:{"confirm":_vm.confirm}}):_vm._e(),(_vm.current==2)?_c('create-video',{on:{"confirm":_vm.confirm}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }